import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../api";
import { useAuth } from "./AuthContext";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const { token } = useAuth();
  const [items, setItems] = useState([]);
  const [customerNote, setCustomerNote] = useState("");

  const loadCart = async () => {
    if (!token) { setItems([]); return; }
    const { data } = await api.get("/cart");
    setItems(data.items || []);
  };

  useEffect(() => { loadCart(); }, [token]);

  const addItem = async (product_id, part_id, quantity = 1) => {
    const { data } = await api.post("/cart/items", { product_id, part_id, quantity });
    setItems(data.items || []);
  };
  const updateQty = async (partId, quantity) => {
    const { data } = await api.patch(`/cart/items/${partId}`, { quantity });
    setItems(data.items || []);
  };
  const removeItem = async (partId) => {
    const { data } = await api.delete(`/cart/items/${partId}`);
    setItems(data.items || []);
  };
  const clearLocal = () => { setItems([]); setCustomerNote(""); };

  const value = useMemo(() => ({ items, count: items.reduce((s, i) => s + i.quantity, 0), customerNote, setCustomerNote, addItem, updateQty, removeItem, loadCart, clearLocal }), [items, customerNote]);
  return <CartContext.Provider value={value}>{children}</CartContext.Provider>;
}

export const useCart = () => useContext(CartContext);